import React, { Component } from 'react';
import Divider from '../../artzu-ui/src/Divider';
import MediaQuery from 'react-responsive';
import { Redirect } from 'react-router-dom';
import SideBarContent from '../SideBar/SideBarContent';
import { Link } from 'react-router-dom';
import gql from 'graphql-tag';
import { m } from '../../utils';
import { Query } from 'react-apollo';
import Loading from '../shared/Loading';
import WeekNavigator from './WeekNavigator';
import './index.css';

const query = gql`
  query priceMap(
    $vehicleClass: String!
    $startDate: DateTime!
    $stretch: Int!
    $parkinglotId: Int!
  ) {
    weeklyPriceMap(
      vehicleClass: $vehicleClass
      startDate: $startDate
      stretch: $stretch
      parkinglotId: $parkinglotId
    ) {
      date
      availability {
        price {
          shift
          rate
          utilization
        }
      }
    }
  }
`;

class PriceMap extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      vehicleClass,
      startDate,
      stretch,
      navigateWeek,
      bgcColour,
      formatShift,
      shifts,
      parkinglotId
    } = this.props;
    return (
      <Query
        query={query}
        fetchPolicy="network-only"
        variables={{ vehicleClass, startDate, stretch, parkinglotId }}>
        {({ loading, error, data, refetch }) => {
          if (loading)
            return (
              <div className="load-div">
                <Loading size="3x" />
              </div>
            );
          const pMap = data.weeklyPriceMap;
          return (
            <div className="heat-map">
              <WeekNavigator
                startDate={startDate}
                navigateWeek={navigateWeek}
                pMap={pMap}
              />
              <div className="map-area">
                <div className="time-column">
                  {shifts.map(shift => {
                    return (
                      <div>
                        <p>{formatShift(shift)}</p>
                      </div>
                    );
                  })}
                  <div>
                    <p>{formatShift(3)}</p>
                  </div>
                </div>
                <div className="heat-grid">
                  {pMap.map(day => {
                    return (
                      <div className="day-column">
                        {day.availability.price.map(shift => {
                          return (
                            <div
                              className="heat-block"
                              style={{
                                backgroundColor: bgcColour(
                                  shift.utilization >= 1
                                    ? 'Full'
                                    : shift.rate,
                                  vehicleClass
                                )
                              }}></div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
                <div className="time-column"></div>
              </div>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default PriceMap;



// WEBPACK FOOTER //
// ./src/components/PriceMap/HeatMap.js